export const capitalizeString = (str: string) => {
	if (str.length === 0) return str; // Check if the string is empty
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
